// store
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGeoRecordHistoryService = () => {
    // hooks
    const axios = useAxios();
    const store = useStore();
    const { apiUrl } = useStore().state;

    // methods
    const getGeoRecordHistory = async (id: number): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/geo-record-history/geojson/${id}`,
        );
        return res.data;
    };

    const getUndoPreview = async (courseSchemaId: number) => {
        const res = await axios.get(
            `${apiUrl}/geo-record-history/geojson/global-undo-preview/${courseSchemaId}`,
        );
        return res.data;
    };

    const performUndo = async (courseSchemaId: number) => {
        const res = await axios.get(
            `${apiUrl}/geo-record-history/geojson/global-undo/${courseSchemaId}`,
        );
        return res.data;
    };

    const getGeoRecordHistoryLogs = async (): Promise<any> => {
        const res = await axios.get(
            `${apiUrl}/geo-record-history/logs/${store.getters.currentCourseSchema.id}`,
        );
        return res.data;
    };

    return {
        getGeoRecordHistoryLogs,
        getGeoRecordHistory,
        getUndoPreview,
        performUndo,
    };
};
